'use es6';

import { getForm } from 'FormsUI/api/Forms';
import LocalSettings from 'FormsCommonComponents/utils/LocalSettings';
import { ALL_DASHBOARD_FORM_TYPES } from 'FormsUI/constants/Dashboard';
import FormTypes from 'forms-utils-lib/constants/formDefinition/FormTypes';
import LEADIN_API_FORM_TYPES from 'forms-utils-lib/constants/formDefinition/LeadinApiFormTypes';
function createAction(name) {
  return `@@form/${name}`;
}
export const REQUEST_FORM = createAction('REQUEST_FORM');
export const RECEIVE_FORM = createAction('RECEIVE_FORM');
export const SUCCEED_GETTING_FORM = createAction('SUCCEED_GETTING_FORM');
export const FAIL_GETTING_FORM = createAction('FAIL_GETTING_FORM');
function receiveForm(form) {
  return {
    type: RECEIVE_FORM,
    form
  };
}
function succeedGettingForm() {
  return {
    type: SUCCEED_GETTING_FORM
  };
}
function failGettingForm(error) {
  return {
    type: FAIL_GETTING_FORM,
    error
  };
}
export function fetchForm(formGuid, validTypes = []) {
  return dispatch => {
    const validFormTypes = [...ALL_DASHBOARD_FORM_TYPES, ...LEADIN_API_FORM_TYPES, FormTypes.VIDEO_FORM, ...validTypes];
    getForm(formGuid).then(response => {
      if (!LocalSettings.get('dashboard:guid-search-all-types:enabled') && !validFormTypes.includes(response.formType)) {
        dispatch(failGettingForm());
      } else {
        dispatch(receiveForm(response));
        dispatch(succeedGettingForm());
      }
    }, error => {
      dispatch(failGettingForm(error.xhr));
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
    return undefined;
  };
}